import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';

import { isPrerendering } from '../../services/prerender';

function GoogleOAuthBoundary({ children }) {
  if (isPrerendering()) return <>{children}</>;

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      {children}
    </GoogleOAuthProvider>
  );
}

export default GoogleOAuthBoundary;
